<template>
  <benefit-and-offer-details-cards :typeData="typeData"></benefit-and-offer-details-cards>
</template>

<script>
  // 从fromLounge, fromSearch, fromBenifits页面来的
  import BenefitAndOfferDetailsCards from '@/components/BaseUi/BenefitAndOfferDetailsCards';

  const type = 'benefit';
  export default {
    name: 'BenefitDetails',
    components: {
      BenefitAndOfferDetailsCards,
    },
    data() {
      return {
        typeData: null,
      };
    },
    created() {
      this.typeData = {
        vmorcId: this.$route.query.vmorcId,
        lang: this.$i18n.locale,
        type,
      };
    },
  };
</script>

<style></style>
